import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/core/services/common-service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/App.state';
import * as token from 'src/app/store/actions/authToken.actions';
import { selectAuthToken } from 'src/app/store/reducers/authToken.reducer';

@Component({
    selector: 'app-redirect-tiny-url',
    templateUrl: './redirect-tiny-url.component.html',
    standalone: false
})
export class RedirectTinyUrlComponent implements OnInit {
  shortId: string;
  enteredOTP;
  mobilenumber: string;

  constructor(private route: ActivatedRoute, private commonService: CommonService, private store: Store<AppState>) { }

  ngOnInit() {
    this.getSilentToken();

  }

  getSilentToken() {
    this.shortId = this.route.snapshot.paramMap.get("shortId");
    this.commonService.returnLongUrl(this.shortId).subscribe((res) => {
      this.store.dispatch(new token.AuthToken(res['responseId']));
      sessionStorage.setItem("clientToken", res['responseId']);
      window.location.href = res["actUrl"];
     
    })

  }
}
